import { createContext, useContext } from 'react';
import type { CreateFormIdVariant } from './createFormActions';

export const CreateFormContext = createContext<CreateFormIdVariant>('simple');

export const CreateFormProvider = CreateFormContext.Provider;

export const useCreateFormInstanceId = () => useContext(CreateFormContext);
